<div class="example-boundary">

  @if (!graphData) {
    <div class="flex justify-content-center pt-3">
      <p-message severity="info" class="w-8 lg:w-6" [closable]="false">
        <div class="flex align-items-center gap-2">
          <i class="mdi mdi-information-variant-circle mr-2 text-3xl"></i>
          <span>{{ 'ERRORE DATI...' }}</span>
        </div>
      </p-message>
    </div>
  } @else {
    <div #graphContainer class="graph-container w-full" style="position: relative; overflow: hidden; background: white;">
    </div>
  }
</div>
